import { AuthContextProps } from "../components/auth-context";
import Customer from "../types/customer";
import { getData, postData, putData } from "./core";

export default class CustomerApi {
  static unauthorizedUri = "n/accounts/customer";
  static authorizedUri = "a/accounts/customer";
  context?: AuthContextProps;
  constructor(context?: AuthContextProps) {
    this.context = context;
  }
  get() {
    return getData({
      uri: CustomerApi.authorizedUri,
      context: this.context,
    });
  }
  put(data: Customer) {
    return putData({
      uri: CustomerApi.authorizedUri,
      context: this.context,
      data,
    });
  }
  post(data: Customer) {
    return postData({
      uri: CustomerApi.unauthorizedUri,
      data,
    });
  }
}
